import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Switch } from 'react-router-dom';
const FirstNews = () => {
    const [firstNews, setFirstNews] = useState(null);
    const formatTanggalID = (datetimeString) => {
        if (!datetimeString) return "";

        // pastikan formatnya valid untuk Date
        const date = new Date(datetimeString.replace(" ", "T"));

        return new Intl.DateTimeFormat("id-ID", {
            day: "numeric",
            month: "long",
            year: "numeric",
        }).format(date);
    };
      useEffect(() => {
    const fetchNews = async () => {
      //const response = await fetch('/posts/berita/posts.json');
      //const newsList = await response.json();
      const API_BASE = process.env.REACT_APP_API_BASE;
       const response = await fetch(
            `${API_BASE}/news.php?action=list`
        );
        const newsList = await response.json();
      
      if (newsList.data.length > 0) {
        setFirstNews(newsList.data[0]);
      }
    };
    fetchNews();
  }, []);
  return (
     <aside class="widget widget-recent-post with-title" style={{textAlign:'left'}}>
        <h3 class="widget-title">Berita</h3>
        <ul class="widget-post ttm-recent-post-list">
            <li>
                <span class="post-date">{formatTanggalID(firstNews?.created_at)}</span>
                <Link to={`/berita/${firstNews?.id}`}> {firstNews?.title}</Link>
            </li>
        </ul>
    </aside>
  );
}

export default FirstNews;